
import { ServiceLandingPage } from "@/components/service/ServiceLandingPage";

const ElectricalPage = () => {
  const features = [
    {
      title: "Electrical Repairs",
      description: "Fix faulty outlets, circuits, and other electrical issues"
    },
    {
      title: "Panel Upgrades",
      description: "Modernize outdated electrical panels for safety and efficiency"
    },
    {
      title: "Lighting Installation",
      description: "Install new fixtures, recessed lighting, and outdoor lighting"
    },
    {
      title: "Wiring & Rewiring",
      description: "Update old wiring or install new wiring for renovations"
    },
    {
      title: "Electrical Inspections",
      description: "Comprehensive safety inspections to identify potential hazards"
    }
  ];

  const processSteps = [
    {
      title: "Schedule Consultation",
      description: "Book an appointment for an electrician to assess your needs"
    },
    {
      title: "Detailed Quote",
      description: "Receive a transparent estimate with all costs clearly outlined"
    },
    {
      title: "Professional Service",
      description: "Experienced electricians complete the work with minimal disruption"
    },
    {
      title: "Final Inspection",
      description: "Thorough testing to ensure everything works properly and safely"
    }
  ];

  const benefits = [
    {
      title: "Established Professionals",
      description: "Work with electricians who have proven track records in the Oklahoma City area"
    },
    {
      title: "Quality Workmanship",
      description: "All electrical work performed to meet industry standards"
    },
    {
      title: "Emergency Services",
      description: "Available 24/7 for urgent electrical problems"
    },
    {
      title: "Upfront Pricing",
      description: "No surprise costs with clear, detailed estimates"
    },
    {
      title: "Satisfaction Guaranteed",
      description: "Work isn't complete until you're fully satisfied"
    }
  ];

  return (
    <ServiceLandingPage
      title="Electrical Services"
      metaDescription="Professional electrical repairs, installations, and upgrades in Oklahoma City."
      introText="Reliable electrical services for homes and businesses in Oklahoma City from established, experienced electricians."
      features={features}
      processSteps={processSteps}
      benefits={benefits}
      ctaText="Need electrical work done right?"
      ctaButtonText="Get Connected"
      contactText="Fill out the form below to connect with top-rated electricians in OKC."
    />
  );
};

export default ElectricalPage;
